var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"w-50 mx-auto fixed-bottom alert shadow",class:("alert-" + _vm.variant),staticStyle:{"margin-bottom":"100px"}},[_vm._v(_vm._s(_vm.message))])}
var staticRenderFns = []

export { render, staticRenderFns }